export default __webpack_public_path__ + "static/media/1393.7ecf695f.png";